"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateWorldCharacterOrder = void 0;
const WorldCharacter_1 = require("../classes/WorldCharacter");
const definables_1 = require("definables");
const pixel_pigeon_1 = require("pixel-pigeon");
const updateWorldCharacterOrder = (worldCharacterID, order) => {
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldCharacterID);
    worldCharacter.order = order;
    (0, pixel_pigeon_1.setEntityZIndex)(worldCharacter.entityID, worldCharacter.order);
    if (worldCharacter.hasEmote()) {
        (0, pixel_pigeon_1.setEntityZIndex)(worldCharacter.emote.entityID, worldCharacter.order);
    }
};
exports.updateWorldCharacterOrder = updateWorldCharacterOrder;
